<template>
  <b-modal id="assinatura-modal" size="md" button-size="sm" centered header-bg-variant="secondary"
    header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
    @hidden="callParent()">
    <template v-slot:modal-header="">
      <h5>Assinar PCA</h5>
    </template>
    <b-row>
      <b-col cols="6" class="">
        <b-form-group id="input-group-type" label-size="md" label="Tipo" label-for="type">
          <b-form-select v-model="type">
            <b-form-select-option value="S" selected>Senha</b-form-select-option>
            <b-form-select-option value="T">Token</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="6" class="">
        <b-form-group v-if="type === 'S'" id="input-group-password" label-size="md" label="Senha" label-for="password">
          <b-form-input type="text" style="width: 0; height: 0; padding: 0; border: 0"></b-form-input>
          <b-form-input v-model="senha" type="password" autocomplete="new-password"></b-form-input>
        </b-form-group>
        <b-form-group v-else id="input-group-type" label-size="md" label="Certificado" label-for="type">
          <b-form-select v-model="thumbprint">
            <b-form-select-option value="0" disabled selected>Selecione</b-form-select-option>
            <b-form-select-option v-for="cert in certificados" :key="cert.thumbprint" :value="cert.thumbprint">{{
              cert.subjectName
            }}</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <template v-slot:modal-footer="{ cancel }">
      <b-progress :value="curValueBar" :max="maxValueBar" v-if="maxValueBar" class="w-50"></b-progress>
      <b-button size="sm" :disabled="showLoading" variant="secondary" @click="confirmar()" class="w-25">
        <b-spinner v-if="showLoading" small />
        Confirmar
      </b-button>
      <b-button size="sm" variant="outline-secondary" :disabled="showLoading" @click="cancel()" class="w-20">
        Cancelar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { store } from "@/store";
import LacunaWebPKI from "web-pki";
import { Service } from "@/services/mainService";

export default {
  name: "AssinaturaModalComponent",
  props: ["id_pca"],
  data() {
    return {
      type: "S",
      showLoading: false,
      errorMessage: "",
      senha: "",
      thumbprint: 0,
      pki: null,
      tokens: [],
      certificados: null,

      //barra de progresso de assinatura
      curValueBar: null,
      maxValueBar: null,

      listarCertificados: null,
    };
  },
  computed: {},
  methods: {
    confirmar: function () {
      const data = new FormData();
      this.changed = false;
      this.showLoading = true;
      if (this.type == "S") {
        this.curValueBar = 1;
        this.maxValueBar = 3;
        data.append("senha", this.senha);
        data.append("idPCA", this.id_pca);
        Service.$http
          .post(process.env.VUE_APP_ENTREGAS_API + "/PCA/assinarPCA", data, {
            headers: {
              "content-type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.curValueBar = 2;
            this.changed = true;
            this.$toast.success("Assinatura realizada com Sucesso");
          })
          .catch((e) => {
            this.$toast.error(e.response.data.msg);
          })
          .finally(() => {
            this.showLoading = false;
            this.$bvModal.hide("assinatura-modal");
            this.limparProgressBar();
          });
      } else {
        this.curValueBar = 1;
        this.maxValueBar = 50;
        data.append("idPCA", this.id_pca);
        Service.$http
          .post(
            process.env.VUE_APP_ENTREGAS_API + "/PCA/iniciarAssinaturaToken",
            data,
            {
              headers: {
                "content-type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            this.tokens = response.data;
            this.maxValueBar = 4 + this.tokens.length;
            this.curValueBar++;
            this.preauthorizeSignatures();
          })
          .catch((e) => {
            this.$toast.error(e.response.data.msg);
            this.showLoading = false;
            this.limparProgressBar();
          });
      }
    },
    callParent: function () {
      if (this.changed) {
        this.$parent.loadData();
      }
      this.$router.push("/contas-anuais/consulta");
    },
    signAllWithRestPki(tokens) {
      let currentToken = tokens.pop();
      this.pki
        .signWithRestPki({
          token: currentToken,
          thumbprint: this.thumbprint,
        })
        .success((res) => {
          this.curValueBar++;
          if (tokens.length > 0) this.signAllWithRestPki(tokens);
          else this.completeSignature();
        })
        .error((error) => {
          console.error("Falha no signAllWithRestPki", error);
          this.onWebPkiError("Erro ao assinar documento.", error);
          this.limparProgressBar();
        });
    },
    preauthorizeSignatures() {
      this.pki
        .preauthorizeSignatures({
          certificateThumbprint: this.thumbprint,
          signatureCount: this.tokens.length, // number of signatures to be authorized by the user
        })
        .success(() => {
          this.curValueBar++;
          this.signAllWithRestPki(this.tokens.slice(0).map((t) => t.Token));
        })
        .fail((err) => {
          console.error("Falha no pki.preauthorizeSignatures", err);
          this.$toast.error(
            "Falha ao assinar digitalmente a PCA. O serviço de assinaturas parece estar offline. Por favor tente novamente em instantes.",
            {
              timeout: 9000,
            }
          );
          this.showLoading = false;
          this.limparProgressBar();
        });
    },
    completeSignature() {
      let data = this.tokens.map((t) => {
        return { Token: t.Token, CodArquivo: t.CodArquivo };
      });
      Service.$http
        .post(
          process.env.VUE_APP_ENTREGAS_API +
          "/PCA/finalizarAssinaturaToken/" +
          this.id_pca,
          data,
          {
            headers: {
              Authorization: "Bearer " + store.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          this.changed = true;
          this.$toast.success("Assinatura realizada com Sucesso");
        })
        .catch((e) => {
          this.$toast.error(e.response.data.msg);
        })
        .then(() => {
          this.showLoading = false;
          this.$bvModal.hide("assinatura-modal");
          this.limparProgressBar();
        });
    },
    loadCertificates: function () {
      this.pki
        .listCertificates({
          filter: this.pki.filters.isWithinValidity,
        })
        .success((certs) => {
          this.certificados = certs;
          this.listarCertificados = setTimeout(() => { this.loadCertificates(); }, 5000);
        });
    },
    onWebPkiNotInstalled: function (status, msg, arg3, arg4) {
      this.$toast.error("Extensão WebPKI não encontrada");
    },
    onWebPkiFail: function (status, msg, arg3, arg4) {
      this.$toast.error("Extensão WebPKI retornou uma falha.");
      this.limparProgressBar();
    },
    onWebPkiError(message, error, origin) {
      this.$toast.error("Ocorreu um erro ao executar o WebPKI.");
      this.showLoading = false;
      this.limparProgressBar();
    },
    limparProgressBar() {
      this.curValueBar = null;
      this.maxValueBar = null;
    },
  },
  beforeDestroy() {
    if (this.$parent.currentItem) this.$parent.currentItem = null;
    if (this.listarCertificados)
      clearTimeout(this.listarCertificados);
  },
  mounted() {
    if (typeof this.$parent.currentItem !== "undefined") {
      this.$bvModal.show("assinatura-modal");
    } else {
      this.$router.push("/contas-anuais/consulta");
    }
    this.pki = new LacunaWebPKI(process.env.VUE_APP_LACUNA_LICENSE);
    this.pki.init({
      restPkiUrl: process.env.VUE_APP_REST_PKI_URL,
      ready: this.loadCertificates,
      notInstalled: this.onWebPkiNotInstalled,
      defaultFail: this.onWebPkiError,
    });
  },
};
</script>
<style>
.modal-header {
  padding: 0.5rem 1rem;
}

.modal-header h5 {
  margin-bottom: 0 !important;
}

.error-messages {
  font-size: 14px;
  color: red;
}

.form-group label {
  padding-bottom: 0 !important;
  margin-bottom: 5px !important;
}
</style>